import { render } from "./editTitle.vue?vue&type=template&id=78639759"
import script from "./editTitle.vue?vue&type=script&lang=js"
export * from "./editTitle.vue?vue&type=script&lang=js"

import "./editTitle.vue?vue&type=style&index=0&id=78639759&lang=less"
script.render = render

export default script